// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "ec3b1834" + ".chunk.js";
};